(ns ui.components.radix-ui.progress.view
  (:require
   ["@radix-ui/react-progress" :as ProgressPrimitive]
   [reagent.core :as r]
   [oops.core :as oops]))

(defn adapt
  [cls-name]
  (r/adapt-react-class (oops/oget+ ProgressPrimitive cls-name)))

(def progress-primitive (adapt "Root"))
(def progress-indicator-primitive (adapt "Indicator"))
